<mat-card>
  <mat-card-header>
    <mat-card-title>Recepción de {{'Pedido' | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="!isValidating && !hasPermission">No tiene permisos para acceder a esta vista.</mat-label>
    </div>

    <ng-container *ngIf="!isValidating && hasPermission">

      <form [formGroup]="remitoForm">

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">settings</mat-icon>Datos del Remito
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código</mat-label>
                <input matInput formControlName="Codigo" (keyup.enter)="searchItemsPendientesEntrega()" maxlength="100">
                <mat-error *ngIf="!remitoForm.controls['Codigo'].valid && remitoForm.controls['Codigo'].touched">
                  {{ getErrorCodigo() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha de Recepción*</mat-label>
                <input matInput [matDatepicker]="fechaEntregaPicker" formControlName="FechaEntrega" readonly
                  (click)="fechaEntregaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEntregaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEntrega')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaEntregaPicker></mat-datepicker>
                <mat-error
                  *ngIf="!remitoForm.controls['FechaEntrega'].valid && remitoForm.controls['FechaEntrega'].touched">
                  {{ getErrorFechaEntrega() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadDestinoId" (selectionChange)="searchItemsPendientesEntrega()">
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">
                    {{ sharedFunctions.formatComunidadName(s) }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!remitoForm.controls['ComunidadDestinoId'].valid && remitoForm.controls['ComunidadDestinoId'].touched">
                  {{ getErrorComunidadDestino() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{'Proveedor' | translate}}*</mat-label>
                <input type="text" matInput [matAutocomplete]="proveedor" formControlName="Proveedor" style="width: 95%;">
                <div *ngIf="isProveedorSearching" style="float: right;"><i class="fa fa-spinner fa-spin"></i></div>
              </mat-form-field>
              <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor"
                (optionSelected)="searchItemsPendientesEntrega()">
                <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                  {{s.RazonSocial}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="!remitoForm.controls['Proveedor'].valid && remitoForm.controls['Proveedor'].touched">
                {{ getErrorProveedor() }}
              </mat-error>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="comprobanteFile; else newFile">{{selectedFile}}</mat-label>
                <ng-template #newFile>
                  <mat-label class="text-style">Adjuntar remito</mat-label>
                </ng-template>
                <input matInput disabled>
                <button mat-icon-button matSuffix (click)="fileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input hidden (change)="selectFile($event)" #fileInput type="file">
              </mat-form-field>

            </div>

          </div>

        </mat-expansion-panel>

      </form>

      <br />

      <ng-container *ngIf="canView()">

        <mat-expansion-panel *ngIf="!isValidating" [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">receipt</mat-icon> Materiales a Recibir
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="searchForm">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nro. Pedido</mat-label>
                    <input matInput type="number" formControlName="PedidoId" placeholder="Nro. Pedido"
                      aria-label="Nro. Pedido" (keyup.enter)="searchItemsPendientesEntrega()">
                  </mat-form-field>
                </div>
                <!-- FECHA Desde -->
                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Fecha Desde</mat-label>
                    <input matInput [matDatepicker]="fechaDesdePicker" formControlName="FechaEntregaPlanificadaDesde"
                       (click)="fechaDesdePicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix
                      (click)="clearDate('FechaEntregaPlanificadaDesde')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaDesdePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <!-- FECHA HASTA -->
                <div fxFlex=34 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Fecha Hasta</mat-label>
                    <input matInput [matDatepicker]="fechaHastaPicker" formControlName="FechaEntregaPlanificadaHasta"
                       (click)="fechaHastaPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix
                      (click)="clearDate('FechaEntregaPlanificadaHasta')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaHastaPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}</mat-label>
                    <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoMaterialId">
                      <mat-option>Todos</mat-option>
                      <mat-option *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <input type="text" placeholder="Material" aria-label="Material" matInput [matAutocomplete]="material"
                      formControlName="Material" style="width: 95%;">
                    <div *ngIf="isMaterialAutoSearching" style="float: right;"><i class="fa fa-spinner fa-spin"></i></div>
                  </mat-form-field>
                  <mat-autocomplete panelWidth="auto" #material="matAutocomplete" [displayWith]="displayMaterial">
                    <mat-option *ngFor="let s of filteredMaterialList" [value]="s">
                      {{s.Nombre}}
                    </mat-option>
                  </mat-autocomplete>
                </div>

              </div>

            </form>

          </mat-expansion-panel>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
            <button mat-raised-button (click)="searchItemsPendientesEntrega()" [disabled]="isSearching" color="primary"
              class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
            <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">

            <ejs-grid #grid [dataSource]='itemList' [allowPaging]="true" [pageSettings]='pageSettings'
              [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
              [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
              <e-columns>
                <e-column width="15%" field='FechaEntrega' headerText='Entrega Planificada'></e-column>
                <!-- <e-column width="15%" field='ComunidadDestinoNombre' headerText='Comunidad'>
                  <ng-template #headerTemplate let-data>
                    <div>{{'Comunidad' | translate}}</div>
                  </ng-template>
                </e-column> -->
                <e-column width="15%" field='PedidoId' headerText='Pedido'></e-column>
                <e-column width="15%" field='MaterialNombre' headerText='Material'></e-column>
                <e-column width="15%" field='Detalle' headerText='Detalle'></e-column>
                <e-column width="15%" field='CantidadSolicitada' headerText='Cantidad'></e-column>
                <e-column headerText='Cant. Recibida' width="15%"></e-column>
                <!-- <e-column headerText='Observación' width="15%"></e-column> -->
              </e-columns>
              <ng-template #rowTemplate let-data>
                <tr class="e-row">
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.FechaEntrega | date:'dd/MM/yyyy'}}
                  </td>
                  <!-- <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.ComunidadDestinoNombre}}
                  </td> -->
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.PedidoId}}
                  </td>
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.MaterialNombre}}
                  </td>
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.Detalle}}
                  </td>
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    {{data.CantidadSolicitada | number:'1.2-2' }} {{data.UnidadMedidaMaterial}}
                  </td>
                  <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    <input matInput type="number" [(ngModel)]="data.Cantidad" name="Cantidad"
                      (change)="onDetalleRemitoChange(data.index, data.PedidoItemId, $event)"
                      style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                  </td>
                  <!-- <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                    <input matInput type="text" [(ngModel)]="data.Observacion" name="Observacion"
                      (change)="onDetalleRemitoChange(data.index, data.PedidoItemId, $event)"
                      style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                  </td> -->
                </tr>
              </ng-template>
            </ejs-grid>

          </div>

        </mat-expansion-panel>

      </ng-container>

    </ng-container>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canView()" [disabled]="isProcessing()" color="primary"
        class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn"
        class="zb-button">{{hasPermission? 'Cancelar' : 'Cerrar'}}</button>
    </div>
  </mat-card-actions>
</mat-card>
